export interface Configuration {
  attribute: string;
  description: string;
  type: string;
  values: string;
  _id: string;
}